import { RootActions, RootState } from "common/reducers";
import {
  FETCH_AUTHORIZATION,
  FETCH_CHECKOUT_TOKEN,
  PaySimpleCheckoutToken,
  PaySimpleTokenRecord,
  RECEIVE_CHECKOUT_TOKEN,
  RECEIVE_CHECKOUT_TOKEN_ERROR,
  SET_AUTHORIZATION,
} from "common/reducers/paySimple.actions";
import { Record, fromJS, Map } from "immutable";

export const PaySimpleStateRecord = Record({
  authorized: Map<number, boolean>(),
  authorization: Map<number, Map<keyof PaySimpleCheckoutToken, string>>(),
  tokensByOrgId: Map<number, PaySimpleTokenRecord>(),
});

export const initialState = PaySimpleStateRecord({});
export type PaySimpleState = typeof initialState;
export const model = "paySimple";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_AUTHORIZATION:
      if (state.getIn([model, "authorization", action.payload])) {
        return state.setIn([model, "authorization", action.payload, "loading"], true);
      }

      return state.setIn(
        [model, "authorization", action.payload],
        fromJS({ loading: true, username: "", api_key: "", hpp_url: "" }),
      );

    case SET_AUTHORIZATION:
      let newState = state
        .setIn([model, "authorization", action.payload.orgId], fromJS(action.payload.authorization))
        .setIn([model, "authorization", action.payload.orgId, "loading"], false);

      if (
        action.payload.authorization.username &&
        action.payload.authorization.username !== "" &&
        action.payload.authorization.api_key &&
        action.payload.authorization.api_key !== ""
      ) {
        newState = newState.setIn([model, "authorized", action.payload.orgId], true);
      }
      return newState;

    case FETCH_CHECKOUT_TOKEN:
      return state.setIn([model, "tokensByOrgId", action.payload.orgId], new PaySimpleTokenRecord({ loading: true }));

    case RECEIVE_CHECKOUT_TOKEN: {
      const { orgId, token } = action.payload;

      return state
        .setIn([model, "tokensByOrgId", orgId, "loading"], false)
        .setIn([model, "tokensByOrgId", orgId, "token"], fromJS(token));
    }

    case RECEIVE_CHECKOUT_TOKEN_ERROR: {
      const { orgId, error } = action.payload;

      return state
        .setIn([model, "tokensByOrgId", orgId, "loading"], false)
        .setIn([model, "tokensByOrgId", orgId, "error"], error);
    }

    default:
      return state;
  }
};
